import { useState, useEffect, useRef } from "react";

// local import
import "./App.scss";
import Loader from "./components/Loader";
import Hero from "./components/HeroHeader";
import Menu from "./components/Menu";
import About from "./components/About";
import Project from "./components/Project";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Divider = () => (
  <div className="section-divider">
    <span>✦</span>
  </div>
);

const App = () => {
  const [completed, setcompleted] = useState(false);
  const scrollTimer = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      document.body.classList.add("is-scrolling");
      clearTimeout(scrollTimer.current);
      scrollTimer.current = setTimeout(() => {
        document.body.classList.remove("is-scrolling");
      }, 150);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  setTimeout(() => {
    setcompleted(true);
  }, 2000);

  return (
    <>
      {!completed ? (
        <Loader />
      ) : (
        <div className="App">
          <div id="home">
            <Hero />
          </div>
          <Menu />
          <Divider />
          <div id="about">
            <About />
          </div>
          <Divider />
          <div id="projects">
            <h2 className="section-title">Projects</h2>
            <Project />
          </div>
          <Divider />
          <div id="contact">
            <Contact />
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

export default App;
